import { Component } from "react";
import { connect } from "react-redux";
import DataTable from "components/DigiHapi/DataTable";
import { bindActionCreators } from "redux";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import MDWizard from "components/DigiHapi/MDWizard";
import DeleteConfirmationDialog from "components/DigiHapi/DeleteConfirmationDialog";
import SnackBarContainer from "components/DigiHapi/SnackBarContainer";

import { FaCampground } from "react-icons/fa";
import {
	fetchGetCampsiteDetails,
	fetchGetCampsitesNames,
	fetchDeleteCampsite,
	fetchAddCampsite,
	fetchUpdateCampsite
} from "actions/campsite";
import { fetchGetCommunityDetails } from "actions/community";
import {
	RESET_CAMPSITE,
	SET_CAMPSITES_NAME_FILTER,
	SET_CAMPSITES_SORTED,
	SET_DELETE_CAMPSITE_CONFIRMATION_NAME
} from "actions/types";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

class CampsitesWizard extends Component {
	fetchAddCampsite = () => {
		const {
			fetchAddCampsite,
			name,
			stars,
			customUri,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channels
		} = this.props;

		fetchAddCampsite({
			name,
			customUri,
			stars,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channelsIds: Object.values(channels)
		});
	};

	fetchUpdateCampsite = () => {
		const {
			fetchUpdateCampsite,
			_id,
			name,
			customUri,
			stars,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channels
		} = this.props;

		fetchUpdateCampsite({
			_id,
			name,
			customUri,
			stars,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channelsIds: Object.values(channels)
		});
	};

	render() {
		const { update, isFetching, onClose } = this.props;
		return (
			<Grid item xs={12}>
				<MDWizard
					onClose={onClose}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Illustration",
							stepComponent: Step1,
							stepId: "picture"
						},
						{
							stepName: "Informations",
							stepComponent: Step2,
							stepId: "infos"
						},
						{
							stepName: "Localisation",
							stepComponent: Step3,
							stepId: "localisation"
						}
					]}
					title={update ? "Mise à jour d'un camping" : "Ajout d'un camping"}
					finishButtonClick={
						update ? this.fetchUpdateCampsite : this.fetchAddCampsite
					}
				/>
			</Grid>
		);
	}
}

class CampsitesPage extends Component {
	state = {
		wizard: null,
		alert: null,
		name: "",
		campsiteToDelete: null
	};

	componentDidMount() {
		this.props.fetchGetCampsitesNames();
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetCampsitesNames,
			snackInfoMsg,
			newWizard,
			page,
			limit,
			sorted,
			nameFilter
		} = this.props;

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetCampsitesNames(page, limit, sorted, nameFilter);
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_CAMPSITE
		});
	};

	addWizard = (update = true) => {
		this.setState({
			wizard: (
				<ConnectedCampsitesWizard update={update} onClose={this.onClose} />
			)
		});
	};

	changeCommunity = id => {
		this.props.fetchGetCommunityDetails(id);
	};

	editCampsite = id => {
		this.props.fetchGetCampsiteDetails(id);
	};

	deleteCampsite = id => {
		this.props.fetchDeleteCampsite(id, this.props.deleteConfirmationName);
	};

	getRoundButtons = (id, name) => {
		return [
			{
				color: "success",
				icon: "where_to_vote",
				onClick: this.changeCommunity
			},
			{
				color: "info",
				icon: "edit",
				onClick: this.editCampsite
			},
			{
				color: "error",
				icon: "delete",
				onClick: this.delete
			}
		].map(prop => (
			<MDButton
				key={prop.icon}
				variant="gradient"
				color={prop.color}
				size="small"
				iconOnly
				circular
				disabled={!!this.state.wizard}
				onClick={() => prop.onClick(id, name)}
				sx={{ mx: 0.25 }}
			>
				<Icon>{prop.icon}</Icon>
			</MDButton>
		));
	};

	getCampsites = () => {
		const { campsitesNames } = this.props;

		const campsitesObj = Object.values(campsitesNames).map(({ _id, name }) => {
			return {
				name,
				actions: (
					<MDBox display="flex" justifyContent="flex-end">
						{this.getRoundButtons(_id, name)}
					</MDBox>
				)
			};
		});
		return campsitesObj;
	};

	delete = (communityId, campsiteName) => {
		this.setState({ campsiteToDelete: { communityId, campsiteName } });
	};

	render() {
		const { alert, campsiteToDelete } = this.state;
		const {
			isFetchingList,
			dispatch,
			page,
			totalPages,
			limit,
			sorted,
			fetchGetCampsitesNames,
			nameFilter,
			snackInfoMsg,
			snackErrorMsg
		} = this.props;

		return (
			<SnackBarContainer
				snackInfoMsg={snackInfoMsg}
				snackErrorMsg={snackErrorMsg}
			>
				<Grid container spacing={3} justifyContent="center">
					{alert}
					<Grid item xs={12}>
						<Card>
							<MDBox
								mx={2}
								mt={-3}
								py={2}
								px={2}
								variant="gradient"
								bgColor="primary"
								borderRadius="lg"
								coloredShadow="primary"
								display="flex"
								alignItems="center"
								color="white"
							>
								<FaCampground size={24} />
								<MDTypography variant="h6" color="white" ml={1.5}>
									Campings
								</MDTypography>
							</MDBox>
							<MDBox p={2}>
								<DataTable
									data={this.getCampsites()}
									filterable
									columns={[
										{
											Header: "Nom",
											accessor: "name",
											sortable: true,
											filterable: true
										},
										{
											Header: "Actions",
											accessor: "actions",
											sortable: false,
											filterable: false
										}
									]}
									showPaginationTop
									showPaginationBottom={false}
									manual
									manualFilters
									onFetchData={state => {
										if (
											page !== state.page + 1 ||
											limit !== state.pageSize ||
											sorted !== state.sorted ||
											nameFilter !== state.filtered?.[0]?.value
										) {
											dispatch({
												type: SET_CAMPSITES_SORTED,
												value: state.sorted
											});
											dispatch({
												type: SET_CAMPSITES_NAME_FILTER,
												value: state.filtered?.[0]?.value
											});
											fetchGetCampsitesNames(
												state.page + 1,
												state.pageSize,
												state.sorted,
												state.filtered?.[0]?.value
											);
										}
									}}
									loading={isFetchingList}
									defaultPageSize={limit}
									defaultSorted={sorted}
									page={page - 1}
									pageSizeOptions={[5, 10, 15, 20, 40, 80]}
									pages={totalPages}
									previousText="Précédent"
									nextText="Suivant"
									rowsText="Lignes"
									noDataText="Aucuns campings"
									ofText="sur"
									loadingText="Chargement..."
								/>
							</MDBox>
							<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
								<MDButton
									variant="gradient"
									color="primary"
									onClick={() => this.addWizard(false)}
									disabled={Boolean(this.state.wizard)}
								>
									<Icon>add</Icon>
									&nbsp;{"Ajout d'un camping"}
								</MDButton>
							</MDBox>
						</Card>
					</Grid>
					{this.state.wizard}
				</Grid>
				<DeleteConfirmationDialog
					open={!!campsiteToDelete}
					message="Êtes-vous sûr de vouloir supprimer le camping ?"
					instruction={`Confirmer la suppression du camping en saisisant le nom du camping ${
						campsiteToDelete?.campsiteName || ""
					}`}
					inputLabel="Camping ..."
					inputId="camping"
					onInputChange={e =>
						dispatch({
							type: SET_DELETE_CAMPSITE_CONFIRMATION_NAME,
							value: e.target.value
						})
					}
					onCancel={() => this.setState({ campsiteToDelete: null })}
					onConfirm={() => {
						this.deleteCampsite(campsiteToDelete.communityId);
						this.setState({ campsiteToDelete: null });
					}}
				/>
			</SnackBarContainer>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		name,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		citiesTags,
		customUri,
		campsitesNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter,
		stars
	} = state.campsiteReducer;

	return {
		_id,
		isFetching,
		isFetchingList,
		name,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		citiesTags,
		customUri,
		campsitesNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter,
		stars
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetCampsitesNames,
			fetchGetCampsiteDetails,
			fetchDeleteCampsite,
			fetchAddCampsite,
			fetchUpdateCampsite,
			fetchGetCommunityDetails
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedCampsitesWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(CampsitesWizard);

export default {
	CampsitesPage: connect(mapStateToProps, mapDispatchToProps)(CampsitesPage),
	CampsitesWizard: ConnectedCampsitesWizard
};
